import ReactMarkdown from "react-markdown";
import {
  policyMarkdownComponents,
  policyRemarkPlugins,
} from "./policyMarkdownComponents";

type PolicyMarkdownProps = {
  children: string;
};

/** Venue policy/terms copy with GFM tables and shared typography. */
export function PolicyMarkdown({ children }: PolicyMarkdownProps) {
  return (
    <ReactMarkdown
      remarkPlugins={policyRemarkPlugins}
      components={policyMarkdownComponents}
    >
      {children}
    </ReactMarkdown>
  );
}